// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog() {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '12px',
          padding: '8px'
        }
      }
    }
  };
}
